import 'jquery';
import 'bootstrap';
import 'slick-carousel';
import 'simplelightbox';
import 'cookieconsent';

import './cookies.js';

import '../sass/main.sass';

function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../../src/templates/', true, /\.ss$/));
requireAll(require.context('../../src/img/', true, /\.(gif|png|jpe?g|svg)$/));
requireAll(require.context('../../src/fonts/', true, /\.(eot|svg|ttf|woff|woff2|otf)$/));


/*
 * REAL CODE FROM HERE!
 */
/**
 *  This inits the slick slider
 *  and gives it some initial settings
 */
$('.inspiration-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.advantage-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    fade: true,
    autoplaySpeed: 2000,
});


// Select all links with hashes
$('a.scroll-to[href*="#"]')
// Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1500, function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    }
                    ;
                });
            }
        }
    });



var vpanimations = $('[data-vpanim="true"]');

$(document).ready(function () {

    if($('div.inspiration-slider').length) {
        $('.inspiration-slider .slick-slide:not(".slick-cloned") a').simpleLightbox();
    }

    const $advantagesliders = $('div.advantage-slider');
    $advantagesliders.each((ind, slider) =>
        $(slider).find("a").simpleLightbox()
    );

    $.each(vpanimations, function () {
        if ($(this).isInViewport()) {
            if (!$(this).hasClass('animated')) {
                $(this).addClass('animated ' + $(this).data('vpanimeffect') + ' delay-' + $(this).data('vpanimdelay'));
            }
        }
    });

    if(!$('#Form_ContactForm_error').is(':empty')){
        console.log('Kontaktformular hat was zu sagen!')
        $('html, body').animate({
            scrollTop: $('#contact-section').offset().top
        }, 1000);
    }

    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            $('#back-to-top').fadeIn();
        } else {
            $('#back-to-top').fadeOut();
        }
    });
    // scroll body to 0px on click
    $('#back-to-top').click(function () {
        $('#back-to-top').hide();
        $('body,html').animate({
            scrollTop: 0
        }, 1500);
        return false;
    });

    $('#back-to-top').show();

});

$(window).on('resize scroll', function () {

    $.each(vpanimations, function () {
        if ($(this).isInViewport()) {
            if (!$(this).hasClass('animated')) {
                $(this).addClass('animated ' + $(this).data('vpanimeffect') + ' delay-' + $(this).data('vpanimdelay'));
            }
        } else {
            if ($(this).hasClass('animated')) {
                $(this).removeClass('animated ' + $(this).data('vpanimeffect') + ' delay-' + $(this).data('vpanimdelay'));
            }
        }
    });

});



$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.fn.isFullyInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementTop >= viewportTop && elementBottom <= viewportBottom;
};



// WEBPACK FOOTER //
// ./src/js/app.js